import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow, normalizeClass as _normalizeClass, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "el-picker-panel__body-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "el-picker-panel__sidebar"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "el-picker-panel__body" }
const _hoisted_5 = {
  key: 0,
  class: "el-date-picker__time-header"
}
const _hoisted_6 = { class: "el-date-picker__editor-wrap" }
const _hoisted_7 = { class: "el-date-picker__editor-wrap" }
const _hoisted_8 = ["aria-label"]
const _hoisted_9 = ["aria-label"]
const _hoisted_10 = ["aria-label"]
const _hoisted_11 = ["aria-label"]
const _hoisted_12 = { class: "el-picker-panel__content" }
const _hoisted_13 = { class: "el-picker-panel__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_time_pick_panel = _resolveComponent("time-pick-panel")!
  const _component_date_table = _resolveComponent("date-table")!
  const _component_year_table = _resolveComponent("year-table")!
  const _component_month_table = _resolveComponent("month-table")!
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_clickoutside = _resolveDirective("clickoutside")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["el-picker-panel el-date-picker", [{
      'has-sidebar': _ctx.$slots.sidebar || _ctx.hasShortcuts,
      'has-time': _ctx.showTime
    }]])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "sidebar", { class: "el-picker-panel__sidebar" }),
      (_ctx.hasShortcuts)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shortcuts, (shortcut, key) => {
              return (_openBlock(), _createElementBlock("button", {
                key: key,
                type: "button",
                class: "el-picker-panel__shortcut",
                onClick: ($event: any) => (_ctx.handleShortcutClick(shortcut))
              }, _toDisplayString(shortcut.text), 9, _hoisted_3))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.showTime)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("span", _hoisted_6, [
                _createVNode(_component_el_input, {
                  placeholder: _ctx.t('Controls.DatePicker.SelectDate'),
                  "model-value": _ctx.visibleDate,
                  size: "small",
                  onInput: _cache[0] || (_cache[0] = val => _ctx.userInputDate = val),
                  onChange: _ctx.handleVisibleDateChange
                }, null, 8, ["placeholder", "model-value", "onChange"])
              ]),
              _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_7, [
                _createVNode(_component_el_input, {
                  placeholder: _ctx.t('Controls.DatePicker.SelectTime'),
                  "model-value": _ctx.visibleTime,
                  size: "small",
                  onFocus: _ctx.onTimePickerInputFocus,
                  onInput: _cache[1] || (_cache[1] = val => _ctx.userInputTime = val),
                  onChange: _ctx.handleVisibleTimeChange
                }, null, 8, ["placeholder", "model-value", "onFocus", "onChange"]),
                _createVNode(_component_time_pick_panel, {
                  visible: _ctx.timePickerVisible,
                  format: _ctx.timeFormat,
                  "time-arrow-control": _ctx.arrowControl,
                  "parsed-value": _ctx.innerDate,
                  onPick: _ctx.handleTimePick,
                  "display-as-week-range": _ctx.displayAsWeekRange
                }, null, 8, ["visible", "format", "time-arrow-control", "parsed-value", "onPick", "display-as-week-range"])
              ])), [
                [_directive_clickoutside, _ctx.handleTimePickClose]
              ])
            ]))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("div", {
          class: _normalizeClass(["el-date-picker__header", { 'el-date-picker__header--bordered': _ctx.currentView === 'year' || _ctx.currentView === 'month' }])
        }, [
          _createElementVNode("button", {
            type: "button",
            "aria-label": _ctx.t(`Controls.DatePicker.PrevYear`),
            class: "el-picker-panel__icon-btn el-date-picker__prev-btn el-icon-d-arrow-left",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.prevYear_ && _ctx.prevYear_(...args)))
          }, null, 8, _hoisted_8),
          _withDirectives(_createElementVNode("button", {
            type: "button",
            "aria-label": _ctx.t(`Controls.DatePicker.PrevMonth`),
            class: "el-picker-panel__icon-btn el-date-picker__prev-btn el-icon-arrow-left",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.prevMonth_ && _ctx.prevMonth_(...args)))
          }, null, 8, _hoisted_9), [
            [_vShow, _ctx.currentView === 'date']
          ]),
          _withDirectives(_createElementVNode("span", {
            role: "button",
            class: _normalizeClass(["el-date-picker__header-label", { active: _ctx.currentView === 'month' }]),
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.showMonthPicker && _ctx.showMonthPicker(...args)))
          }, _toDisplayString(_ctx.t(`Controls.DatePicker.Month`)) + " " + _toDisplayString(_ctx.month + 1), 3), [
            [_vShow, _ctx.currentView === 'date']
          ]),
          _createElementVNode("span", {
            role: "button",
            class: "el-date-picker__header-label",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.showYearPicker && _ctx.showYearPicker(...args)))
          }, _toDisplayString(_ctx.yearLabel), 1),
          _createElementVNode("button", {
            type: "button",
            "aria-label": _ctx.t(`Controls.DatePicker.NextYear`),
            class: "el-picker-panel__icon-btn el-date-picker__next-btn el-icon-d-arrow-right",
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.nextYear_ && _ctx.nextYear_(...args)))
          }, null, 8, _hoisted_10),
          _withDirectives(_createElementVNode("button", {
            type: "button",
            "aria-label": _ctx.t(`Controls.DatePicker.NextMonth`),
            class: "el-picker-panel__icon-btn el-date-picker__next-btn el-icon-arrow-right",
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.nextMonth_ && _ctx.nextMonth_(...args)))
          }, null, 8, _hoisted_11), [
            [_vShow, _ctx.currentView === 'date']
          ])
        ], 2), [
          [_vShow, _ctx.currentView !== 'time']
        ]),
        _createElementVNode("div", _hoisted_12, [
          (_ctx.currentView === 'date')
            ? (_openBlock(), _createBlock(_component_date_table, {
                key: 0,
                "selection-mode": _ctx.selectionMode,
                date: _ctx.innerDate,
                "parsed-value": _ctx.parsedValue,
                "disabled-date": _ctx.disabledDate,
                "display-as-week-range": _ctx.displayAsWeekRange,
                onPick: _ctx.handleDatePick
              }, null, 8, ["selection-mode", "date", "parsed-value", "disabled-date", "display-as-week-range", "onPick"]))
            : _createCommentVNode("", true),
          (_ctx.currentView === 'year')
            ? (_openBlock(), _createBlock(_component_year_table, {
                key: 1,
                date: _ctx.innerDate,
                "disabled-date": _ctx.disabledDate,
                "parsed-value": _ctx.parsedValue,
                onPick: _ctx.handleYearPick
              }, null, 8, ["date", "disabled-date", "parsed-value", "onPick"]))
            : _createCommentVNode("", true),
          (_ctx.currentView === 'month')
            ? (_openBlock(), _createBlock(_component_month_table, {
                key: 2,
                date: _ctx.innerDate,
                "parsed-value": _ctx.parsedValue,
                "disabled-date": _ctx.disabledDate,
                onPick: _ctx.handleMonthPick
              }, null, 8, ["date", "parsed-value", "disabled-date", "onPick"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_13, [
      _withDirectives(_createVNode(_component_el_button, {
        size: "mini",
        type: "text",
        class: "el-picker-panel__link-btn",
        onClick: _ctx.changeToNow
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t('Controls.DatePicker.Now')), 1)
        ]),
        _: 1
      }, 8, ["onClick"]), [
        [_vShow, _ctx.selectionMode !== 'dates']
      ]),
      _createVNode(_component_el_button, {
        plain: "",
        size: "mini",
        class: "el-picker-panel__link-btn",
        onClick: _ctx.onConfirm
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t('Controls.DatePicker.Confirm')), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ], 512), [
      [_vShow, _ctx.footerVisible && _ctx.currentView === 'date']
    ])
  ], 2))
}